var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout d-flex align-items-center justify-content-center m-0 bg-white"},[_c('child')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }